import { render, staticRenderFns } from "./payMethod.vue?vue&type=template&id=73b74402&scoped=true"
import script from "./payMethod.vue?vue&type=script&lang=js"
export * from "./payMethod.vue?vue&type=script&lang=js"
import style0 from "./payMethod.vue?vue&type=style&index=0&id=73b74402&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b74402",
  null
  
)

export default component.exports